export default "__VITE_ASSET__RxY$$T6j__"